import React from 'react';
import { Section } from './Page.styles'
import logoReel from '../images/logo-reel-bw.jpg';
import styled, { keyframes } from 'styled-components'
import Fade from 'react-reveal/Fade'

const CustomSection = styled(Section)`
	flex-direction: column;
`;

const Title = styled.h2`
    color: #000;
	font-size: 24px;
	text-align: center;
	max-width: 90%;
	margin: 5rem auto 3rem;
`;

const LogoReel = styled.div`
	position: relative;
	height: 200px;
	width: 100%;
    overflow: hidden;
`;

const Slideshow = keyframes`
    0%  { transofmr: translateX(0px) }
  100%  { transform: translateX(-2500px) }
`;

const Images = styled.div`
	background: url(${logoReel});
    position: absolute;
    left: 0;
    top: 0;
    height: 200px;
    width: 5000px;
    animation: ${Slideshow} 20s linear infinite;
    transform: translate3d(0, 0, 0);
    overflow: hidden;

`;

const Featured = () => {
	return (
	    <CustomSection>
            <Fade duration={500} up>
                <Title>
                    Featured with his business partner, Todd Cahill, on:
                </Title>
            </Fade>
            <LogoReel>
                <Images />
            </LogoReel>
        </CustomSection>
	)
}

export default Featured;
